import { render, staticRenderFns } from "./add-rule.vue?vue&type=template&id=15f1b2e7&"
import script from "./add-rule.vue?vue&type=script&lang=js&"
export * from "./add-rule.vue?vue&type=script&lang=js&"
import style0 from "./add-rule.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./add-rule.vue?vue&type=style&index=1&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports